<template>
 <a-modal v-model="visible" :width="this.settings['isMobileView'] ? 480 : this.settings['isTabletView'] ? 720 : 1080" style="top: 20px;">
  <template slot="title">
      <span class="mr-4">Applicant's Details</span>
      <button
        type="button"
        class="btn btn-primary btn-with-addon"
        @click="print"
      >
        <span class="btn-addon">
          <i class="btn-addon-icon fe fe-printer" />
        </span>
        Print
      </button>
  </template>
  <template slot="footer">
    <div class="row">
      <div class="col-md-6 text-left">
        <div v-if="applicantData && applicantData.status < 1">
          <!-- Approve -->
          <a href="javascript:;"
            :class="['btn btn-sm btn-success btn-with-addon mr-2', applicantData.form_status !== 3 ? 'disabled' : '']"
            @click="handleApprove(applicantData)"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-check" />
            </span>
            <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
            Approve
          </a>
          <!-- Decline -->
          <a href="javascript:;"
            :class="['btn btn-sm btn-danger btn-with-addon mr-2', applicantData.form_status !== 3 ? 'disabled' : '']"
            @click="handleDecline(applicantData)"
          >
            <span class="btn-addon">
              <i class="btn-addon-icon fe fe-x" />
            </span>
            <!-- <edit-board ref="editBoard" @edited="handleEdited"/> -->
            Decline
          </a>
        </div>
      </div>
      <div class="col-md-6 text-md-right">
        <a-button key="back" @click="handleCancel">Close</a-button>
        </div>
      </div>
  </template>
    <a-spin :spinning="loading">
      <div id="applicantForm">
        <neo-print-wrapper title="Application Form" :footer="false">
          <div v-if="applicantData">

            <div v-if="applicantData.status === 1">
              <a-alert message="Student has been rejected!" type="error" show-icon>
              </a-alert>
            </div>
            <div v-if="applicantData.status === 3">
              <a-alert message="Student has been admitted!" type="success" show-icon>
              </a-alert>
            </div>

            <div class="row mb-3" v-if="applicantData.form_status === 3 && applicantData.status === 3">
              <div class="col-6 mb-2">
                <p class="font-weight-bold mb-1">Status :
                  <span class="font-size-18 font-weight-normal ml-3 text-uppercase">Admitted</span>
                </p>
              </div>
              <div class="col-6 mb-2">
                <p class="font-weight-bold mb-1">Student Code :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.student.student_code}}</span>
                </p>
              </div>
            </div>

            <p class="font-weight-bold text-uppercase text-muted mt-3">Application No.: <span class="ml-2 text-dark">{{applicantData.application_no}}</span></p>
            <hr>

            <p class="font-weight-bold text-uppercase text-muted mt-3">Personal Data</p>
            <div class="row">
              <div class="col-md-2 order-md-2">
                <div>
                  <p class="font-weight-bold mb-1">Student Photo:</p>
                  <img v-if="applicantData.photo" :src="applicantData.photo" alt="student photo" class="img-fluid mb-2" width="150">
                </div>
              </div>
              <div class="col-md-10 order-md-1">
                <div class="row mb-3">
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Student's Full Name :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.student_first_name}}</span>
                    </p>
                  </div>
                  <!-- <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Student's Last Name :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.student_last_name}}</span>
                    </p>
                  </div> -->
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Date of birth :
                      <span class="font-size-18 font-weight-normal ml-3">{{moment(applicantData.dob).format('DD-MM-YYYY')}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Gender :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.gender}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Nationality :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.nationality}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Aadhaar No :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.aadhaar_no}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Category :
                      <span class="font-size-18 font-weight-normal ml-3">
                        {{find(categoryTypes, {value: applicantData.category}).name}}
                      </span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Language :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.language}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Religion :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.religion}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Tattoo on visible part of body :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.visible_tattoo === 1 ? 'Yes' : 'No'}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Differently Abled Person? :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.disabled === 1 ? 'Yes' : 'No'}}</span>
                    </p>
                  </div>
                  <div class="col-md-6 col-sm-6 mb-2">
                    <p class="font-weight-bold mb-1">Orphan? :
                      <span class="font-size-18 font-weight-normal ml-3">{{applicantData.orphan === 1 ? 'Yes' : 'No'}}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Transport Details</p>
            <div class="row mb-3">
              <div class="col-lg-4 col-md-4 mb-2">
                <p class="font-weight-bold mb-1">Requires transport:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.require_transport === 1 ? 'Yes' : 'No'}}</span>
                </p>
              </div>
              <div class="col-lg-8 col-md-8 mb-2">
                <p class="font-weight-bold mb-1">Preferred transport pickup point:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.transport_pickup_point}}</span>
                </p>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Contact Details (Present)</p>
            <div class="row mb-3">
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Phone :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_country_code}}{{applicantData.contact_phone}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Email :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_email}}</span>
                </p>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-8 mb-2">
                <p class="font-weight-bold mb-1">Street Address :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_address}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">City :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_city}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">District :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_district}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Landmark :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_landmark}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">State :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_state}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Pincode :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_pincode}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Country :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.contact_country}}</span>
                </p>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Contact Details (Permanent)</p>
            <div class="row mb-3">
              <div class="col-md-12 mb-2">
                <p class="font-weight-bold mb-1">Is same with present address :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_same_as_present === 1 ? 'Yes' : 'No'}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Phone :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_country_code}}{{applicantData.permanent_contact_phone}}</span>
                </p>
              </div>
              <div class="col-lg-8 col-md-8 col-sm-8 mb-2">
                <p class="font-weight-bold mb-1">Street Address :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_address}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">City :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_city}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">District :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_district}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Landmark :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_landmark}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">State :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_state}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Pincode :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_pincode}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Country :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.permanent_contact_country}}</span>
                </p>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Parent Details</p>
            <p class="font-weight-bold text-muted mt-3">Father's Details</p>
            <div class="row mb-3">
              <div class="col-lg-6 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Father's Full Name :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.father_suffix}}. {{applicantData.father_first_name}}</span>
                </p>
              </div>
              <!-- <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Father's Last Name :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.father_last_name}}</span>
                </p>
              </div> -->
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Contact Phone :
                  <span class="font-size-18 font-weight-normal ml-3" v-if="applicantData.father_contact_phone">
                    {{applicantData.father_contact_country_code}}{{applicantData.father_contact_phone}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Whatsapp no :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{applicantData.father_whatsapp_phone}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
                <p class="font-weight-bold mb-1">Father's Qualification :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{find(qualifications, {value: applicantData.father_qualification}).name}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
                <p class="font-weight-bold mb-1">Father's Occupation :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{find(occupations, {value: applicantData.father_occupation}).name}}
                  </span>
                </p>
              </div>
            </div>

            <p class="font-weight-bold text-muted mt-3">Mother's Details</p>
            <div class="row mb-3">
              <div class="col-lg-6 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Mother's Full Name :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.mother_suffix}}. {{applicantData.mother_first_name}}</span>
                </p>
              </div>
              <!-- <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Mother's Last Name :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.mother_last_name}}</span>
                </p>
              </div> -->
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Contact Phone :
                  <span class="font-size-18 font-weight-normal ml-3" v-if="applicantData.mother_contact_phone">
                    {{applicantData.mother_contact_country_code}}{{applicantData.mother_contact_phone}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Whatsapp no :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{applicantData.mother_whatsapp_phone}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
                <p class="font-weight-bold mb-1">Mother's Qualification :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{find(qualifications, {value: applicantData.mother_qualification}).name}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
                <p class="font-weight-bold mb-1">Mother's Occupation :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{find(occupations, {value: applicantData.mother_occupation}).name}}
                  </span>
                </p>
              </div>
            </div>

            <p class="font-weight-bold text-muted mt-3">Guardian's Details</p>
            <div class="row mb-3">
              <div class="col-lg-6 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Guardian's Full Name :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.guardian_first_name ? applicantData.guardian_suffix + '.' : ''}} {{applicantData.guardian_first_name}}</span>
                </p>
              </div>
              <!-- <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Guardian's Last Name :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.guardian_last_name}}</span>
                </p>
              </div> -->
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Contact Phone :
                  <span class="font-size-18 font-weight-normal ml-3" v-if="applicantData.guardian_contact_phone">
                    {{applicantData.guardian_contact_country_code}}{{applicantData.guardian_contact_phone}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Whatsapp no :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{applicantData.guardian_whatsapp_phone}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
                <p class="font-weight-bold mb-1">Guardian's Qualification :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{applicantData.guardian_qualification ? find(qualifications, {value: applicantData.guardian_qualification}).name : ''}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2" v-if="false">
                <p class="font-weight-bold mb-1">Guardian's Occupation :
                  <span class="font-size-18 font-weight-normal ml-3">
                    {{applicantData.guardian_occupation ? find(occupations, {value: applicantData.guardian_occupation}).name : ''}}
                  </span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Relation with student :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.guardian_relation_with_student}}</span>
                </p>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Examination Details</p>
            <div class="row mb-3">
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Board :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.board}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Qualifying exam :
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.qualifying_exam_name}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Board Roll No.:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.board_roll_no}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Result status:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.result_status === 1 ? 'Declared' : 'Awaited' }}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Exam total marks obtained:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.exam_total_score}}</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Year of passing:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.year_of_passing}}</span>
                </p>
              </div>
            </div>

            <div v-if="applicantData.applicant_marks.length">
              <hr />
              <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Marks</p>
              <p class="font-weight-bold">Examination score per subject</p>

              <vue-custom-scrollbar class="scroll-area">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Subject</th>
                      <th scope="col">Score</th>
                      <th scope="col">Full Mark</th>
                      <th scope="col">Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="mark in applicantData.applicant_marks" :key="mark.id">
                      <th scope="row">
                          {{ mark.subject }}
                      </th>
                      <td>
                          {{ mark.score }}
                      </td>
                      <td>
                          {{ mark.full_mark }}
                      </td>
                      <td>
                          {{ mark.status === 1 ? 'Pass' : 'Fail' }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </vue-custom-scrollbar>
            </div>

            <hr />
            <div class="row mt-3">
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">PC Score:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.pc_score}}%</span>
                </p>
              </div>
              <div class="col-lg-4 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Grade:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.grade}}</span>
                </p>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Extra curricular</p>
            <p class="font-weight-bold">Awards / Achievements (if any / latest two / most significant two)</p>

            <div>
              <vue-custom-scrollbar class="scroll-area">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Received when</th>
                      <th scope="col">Received for</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="index in 2" :key="index">
                      <th scope="row" style="height:2rem;">
                          {{ applicantData['ec' + index + '_name'] }}
                      </th>
                      <td style="height:2rem;">
                          {{ applicantData['ec' + index + '_when'] }}
                      </td>
                      <td style="height:2rem;">
                          {{ applicantData['ec' + index + '_for'] }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </vue-custom-scrollbar>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase mt-3 mb-1">Last school details</p>
            <div class="row mt-3">
              <div class="col-lg-6 col-md-8 col-sm-12 mb-2">
                <p class="font-weight-bold mb-1">School name:
                  <span class="font-size-18 font-weight-normal ml-3">{{applicantData.last_school_name}}</span>
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">School Type:
                  <span class="font-size-18 font-weight-normal text-capitalize ml-3">{{applicantData.last_school_type}}</span>
                </p>
              </div>
              <div class="col-lg-3 col-md-6 col-sm-6 mb-2">
                <p class="font-weight-bold mb-1">Medium of study:
                  <span class="font-size-18 font-weight-normal text-capitalize ml-3">{{applicantData.last_school_medium}}</span>
                </p>
              </div>
            </div>

            <div v-if="applicantData.subject_group">
              <hr />
              <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Subject grouping opted for admission <span class="text-warning">(Subject Once Opted cannot be changed)</span></p>
              <div class="row mt-3">
                <div class="col-12 mb-3">
                  <p class="font-weight-bold mb-1">
                    <span
                      v-for="(subject, index) in applicantData.subject_group.subjects" :key="subject.id"
                      class="font-size-18 font-weight-normal"
                    >
                      {{getSubjectName(subject, index, applicantData.subject_group.subjects.length)}}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3">Uniform Details</p>
            <div v-if="applicantData.uniforms.length">
              <vue-custom-scrollbar class="scroll-area">
                <table class="table table-bordered table-sm">
                  <thead>
                    <tr>
                      <th scope="col">Uniform</th>
                      <th scope="col">Type</th>
                      <th scope="col">Size</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="uniform in applicantData.uniforms" :key="uniform.id">
                      <th scope="row">
                          {{ uniform.uniform_type.name }}
                      </th>
                      <td>
                          {{ uniform.uniform_type_variant ?  uniform.uniform_type_variant.name : '--' }}
                      </td>
                      <td>
                          {{ uniform.uniform_size.name }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </vue-custom-scrollbar>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Sports</p>
            <div class="mb-2">
              <p class="font-weight-bold mb-1">Is sports person:
                <span class="font-size-18 font-weight-normal text-capitalize ml-3">{{applicantData.sports_person ? 'Yes' : 'No'}}</span>
              </p>
            </div>

            <hr />
            <p class="font-weight-bold text-uppercase text-muted mt-3 mb-1">Uploaded documents</p>
            <div class="row my-3">
              <!-- <div class="col-md-3">
                <p class="font-weight-bold mb-1">Student Photo:</p>
                <img v-if="applicantData.photo" :src="applicantData.photo" alt="student photo" class="img-fluid mb-2" width="150">
              </div> -->
              <div class="col-md-3">
                <p class="font-weight-bold mb-1">Marksheet:</p>
                <div v-if="this.applicantData.document">
                  <a :href="this.applicantData.document" class="btn btn-sm btn-dark d-print-none" target="_blank">View Marksheet</a>
                  <p class="d-none d-print-block">Uploaded</p>
                </div>
              </div>
              <div class="col-md-3">
                <p class="font-weight-bold mb-1">Admit card/Student ID Card:</p>
                <div v-if="this.applicantData.admit_card">
                  <a :href="this.applicantData.admit_card" class="btn btn-sm btn-dark d-print-none" target="_blank">View Admit card</a>
                  <p class="d-none d-print-block">Uploaded</p>
                </div>
              </div>
              <div class="col-md-3" v-if="this.applicantData.sports_person">
                <p class="font-weight-bold mb-1">Sports Cert.:</p>
                <div v-if="this.applicantData.sport_cert">
                  <a :href="this.applicantData.sport_cert" class="btn btn-sm btn-dark d-print-none" target="_blank">View Sport cert.</a>
                  <p class="d-none d-print-block">Uploaded</p>
                </div>
              </div>
            </div>
            <hr />

            <div class="font-weight-bold text-center my-5">
              {{ declaration }}
            </div>

            <div class="d-flex justify-content-between mt-3 mb-2">
              <div class="col-md-4 text-left">
                <img v-if="this.applicantData.parent_signature" :src="this.applicantData.parent_signature" alt="parent / guardian signature" class="img-fluid mb-2" width="200">
                <p class="font-weight-bold mt-2">Parent/Guardian Signature:</p>
              </div>
              <div class="col-md-4 text-right">
                <img v-if="this.applicantData.student_signature" :src="this.applicantData.student_signature" alt="student signature" class="img-fluid mb-2" width="200">
                <p class="font-weight-bold mt-2">Student's Signature:</p>
              </div>
            </div>

          </div>
        </neo-print-wrapper>
      </div>
    </a-spin>
  </a-modal>
</template>

<script>
import moment from 'moment'
import { find } from 'lodash'
import { mapState } from 'vuex'

import NeoPrintWrapper from '@/components/layout/Print/Default'
import vueCustomScrollbar from 'vue-custom-scrollbar'

import { countryCodes, genderTypes, categoryTypes, qualifications, occupations, nameSuffixes } from '@/services/globaldata'

export default {
  name: 'DisplayApplicantForm',
  components: {
    NeoPrintWrapper,
    vueCustomScrollbar,
  },
  mounted: function() {
    this.$eventBus.$on('openShowApplicantFormModal', this.showModal)
  },
  computed: {
    ...mapState(['settings']),
  },
  data() {
    return {
      visible: false,
      loading: false,
      applicantData: null,
      countryCodes,
      genderTypes,
      categoryTypes,
      qualifications,
      occupations,
      nameSuffixes,
      declaration: ' I, hereby solemnly declare that all statements made in the above application are true and correct to the best of my knowledge and belief. Also, I will abide by the rules and regulations of the school.',
    }
  },
  methods: {
    moment,
    find,
    showModal(applicantId) {
      this.getApplicants(applicantId)
      this.visible = true
    },
    getApplicants(applicantId) {
      this.loading = true
      this.applicantData = null
      this.$http.get(`/api/online-applicants/single/${applicantId}`)
        .then(({ data }) => {
          this.applicantData = data.data
          this.loading = false
        })
        .catch(error => {
          console.log(error)
          this.loading = false
        })
    },
    handleApprove(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Click OK to approve ${record.student_first_name} ${record.student_last_name}`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/online-applicants/approve/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Approved Successfully!',
                description: `Applicant ${record.student_first_name} ${record.student_last_name} has been approved successfully!`,
              })
              this.visible = false
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleDecline(record) {
      this.$confirm({
        title: 'Are you sure?',
        content: `Click OK to decline ${record.student_first_name} ${record.student_last_name}`,
        okText: 'Yes',
        okType: 'danger',
        cancelText: 'No',
        onOk: () => {
          this.$nprogress.start()
          this.$http
            .get('/api/online-applicants/decline/' + record.id)
            .then(() => {
              this.$emit('updateTable')
              this.$nprogress.done()
              this.$notification['success']({
                message: 'Applicant Declined!',
                description: `Applicant ${record.student_first_name} ${record.student_last_name} has been declined!`,
              })
              this.visible = false
            })
            .catch(error => {
              this.$nprogress.done()
              this.$neoNotify.error(error)
            })
        },
        onCancel: () => {
          console.log('Cancel')
        },
      })
    },
    handleCancel(e) {
      this.visible = false
    },
    getSubjectName(subject, index, length) {
      if (index < length - 1) {
        return subject.name + ', '
      }
      return subject.name
    },
    print() {
      this.$htmlToPaper('applicantForm')
    },
  },
}
</script>

<style>

</style>
